import bigBottleImage from "./images/big-bottle.png";
import smallBottleImage from "./images/small-bottle.png";
import logo from "./images/logo.jpg";

export const companyInfo = {
  name: "Công ty TNHH nước tinh khiết i-on kiềm O2",
  brandName: "Công Ty TNHH Nước Tinh Khiết I-ON Kiềm O2",
  hotline: "0906 635 113",
  hotlines: ["0906 635 113", "0909 953 806"],
  address: "131/1 Đ. Xuân Thới Sơn 26, Ấp 6, xã Xuân Thới Sơn, TP.HCM",
  email: "contact@ionkiemo2.vn",
  workingHours: "Thứ 2 - Thứ 7: 8:00 - 18:00",
  logo: logo,
  productImage: bigBottleImage,
  socials: {
    facebookPage: "https://www.facebook.com/profile.php?id=61581188233646",
    tiktokProfile: "https://www.tiktok.com/@ctytnhhnuocionkiemo2"
  }
};

export const benefits = [
  {
    id: 1,
    title: "100% Tinh Khiết",
    description: "Nước được lọc qua công nghệ hiện đại, đảm bảo tinh khiết tuyệt đối",
    icon: "droplet"
  },
  {
    id: 2,
    title: "Giàu I-on Kiềm",
    description: "Tăng cường sức khỏe với hàm lượng i-on kiềm tự nhiên",
    icon: "sparkles"
  },
  {
    id: 3,
    title: "An Toàn Tuyệt Đối",
    description: "Đạt chuẩn VSATTP, được kiểm định nghiêm ngặt",
    icon: "shield-check"
  },
  {
    id: 4,
    title: "Giao Hàng Nhanh",
    description: "Giao hàng miễn phí trong vòng 2 giờ tại TP.HCM",
    icon: "truck"
  },
  {
    id: 5,
    title: "Giá Cả Hợp Lý",
    description: "Cam kết giá tốt nhất thị trường cho sản phẩm chất lượng",
    icon: "badge-check"
  },
  {
    id: 6,
    title: "Hỗ Trợ 24/7",
    description: "Đội ngũ tư vấn nhiệt tình, sẵn sàng hỗ trợ mọi lúc",
    icon: "headphones"
  }
];

export const products = [
  {
    id: 1,
    name: "Bình 20L - Tiêu Chuẩn",
    description: "Bình nước 20 lít dung tích chuẩn, phù hợp cho gia đình và văn phòng",
    image: bigBottleImage,
    capacity: "20 lít",
    type: "Gia đình",
    features: ["Tinh khiết tuyệt đối", "Giàu i-on kiềm", "Đạt chuẩn VSATTP"],
    imageScale: "large"
  },
  {
    id: 2,
    name: "Combo 4 Bình 20L",
    description: "Combo tiết kiệm cho nhu cầu sử dụng lâu dài",
    image: bigBottleImage,
    capacity: "80 lít",
    type: "Combo",
    features: ["Giá ưu đãi", "Giao hàng miễn phí", "Tặng kèm phụ kiện"],
    imageScale: "large"
  },
  {
    id: 3,
    name: "Chai 250ml - Tiện Lợi",
    description: "Chai nhỏ gọn, tiện mang theo khi đi làm, đi học",
    image: smallBottleImage,
    capacity: "250ml",
    type: "Cá nhân",
    features: ["Nhỏ gọn", "Tiện lợi", "Thiết kế hiện đại"],
    imageScale: "medium"
  }
];

export const aboutContent = {
  vision: "Trở thành nhà cung cấp nước uống hàng đầu tại Việt Nam, mang đến sức khỏe và niềm tin cho mọi gia đình.",
  mission: "Cung cấp sản phẩm nước i-on kiềm chất lượng cao với giá cả hợp lý, dịch vụ chuyên nghiệp và tận tâm.",
  values: [
    "Chất lượng là ưu tiên hàng đầu",
    "Khách hàng là trung tâm",
    "Trách nhiệm với cộng đồng",
    "Đổi mới không ngừng"
  ],
  process: [
    {
      step: 1,
      title: "Thu thập nguồn nước",
      description: "Nguồn nước được lấy từ giếng khoan sâu, đảm bảo sạch và an toàn"
    },
    {
      step: 2,
      title: "Lọc và xử lý",
      description: "Qua hệ thống lọc RO và ion hóa kiềm hiện đại"
    },
    {
      step: 3,
      title: "Kiểm tra chất lượng",
      description: "Mỗi lô sản phẩm đều được kiểm nghiệm nghiêm ngặt"
    },
    {
      step: 4,
      title: "Đóng chai & Vận chuyển",
      description: "Đóng chai trong môi trường vô trùng và giao hàng nhanh chóng"
    }
  ]
};
